module.exports = __webpack_public_path__ + "static/media/k2rpqpy0gc1fgngd.9cf9e511.png";